import React from 'react';
import { useHistory } from 'react-router-dom';
import AppLayout from 'src/views/layout/AppLayout';

function MainPage() {
    const history = useHistory();

    React.useEffect(() => {
        history.replace(`/dashboard`);
    }, []);

    return <AppLayout>loading..</AppLayout>;
}

export default MainPage;
